import { Node, Edge } from "reactflow";
import { processNodesBeforeSave } from "@zapier/canvas-state/src/utils/processNodesBeforeSave";
import { processEdgesBeforeSave } from "@zapier/canvas-state/src/utils/processEdgesBeforeSave";
import { toTemplatedString } from "../../../service/src/app/utils/stringUtils";

export function composeCanvasForTemplate(
  canvasName: string,
  nodes: Node[],
  edges: Edge[],
  resourceMap: { [p: string]: string },
) {
  const name = canvasName || "untitled";

  const newNodes: Node[] = [];
  const newEdges: Edge[] = [];

  for (const node of nodes) {
    // Make a copy of the node, so we don't alter the existing canvas
    // attributionSourceType needs to be last to overwrite original attributionSourceType
    const newNode = {
      ...node,
      data: { ...node.data, attributionSourceType: "TEMPLATE" },
    };

    // Replace real asset IDs in node.data with templated strings from resourceMap
    if (newNode.data.zapId) {
      newNode.data.zapId = toTemplatedString(resourceMap[newNode.data.zapId]);
    } else if (newNode.data.tableId) {
      newNode.data.tableId = toTemplatedString(
        resourceMap[newNode.data.tableId],
      );
    } else if (newNode.data.chatbotId) {
      newNode.data.chatbotId = toTemplatedString(
        resourceMap[newNode.data.chatbotId],
      );
    } else if (newNode.data.projectId) {
      newNode.data.projectId = toTemplatedString(
        resourceMap[newNode.data.projectId],
      );
      if (newNode.data.pageId) {
        newNode.data.pageId = toTemplatedString(
          resourceMap[newNode.data.pageId],
        );
      }
    }

    newNodes.push(newNode);
  }

  for (const edge of edges) {
    // Make a copy of the edge, so we don't alter the existing canvas
    const newEdge = { ...edge };
    newEdges.push(newEdge);
  }

  return {
    id: "_CANVAS_1",
    name: name,
    nodes: processNodesBeforeSave(newNodes),
    edges: processEdgesBeforeSave(newEdges),
  };
}
